import type {
  ChargeMethod,
  NoneableChargeMethod,
  PackageSource,
} from '@mntn-dev/domain-types'
import { PackageSourceEnum } from '@mntn-dev/domain-types'

import {
  AddOnDollarPairs,
  CreditBasedPairs,
  CreditsFirstThenDollarsPairs,
  hasPair,
  MoneyBasedPairs,
  type SourceMethodPair,
} from './pairs.ts'

// ---------------------------------------------------------------------------
// Base cost currency
// ---------------------------------------------------------------------------

export const PairPaysForBaseInCreditsList = CreditBasedPairs

export const payForBaseInCredits = (
  packageSource: PackageSource,
  billingMethod: ChargeMethod
): boolean => hasPair(CreditBasedPairs, packageSource, billingMethod)

export const payForBaseInDollars = (
  packageSource: PackageSource,
  billingMethod: ChargeMethod
): boolean => hasPair(MoneyBasedPairs, packageSource, billingMethod)

// ---------------------------------------------------------------------------
// Add-on cost currency
// ---------------------------------------------------------------------------

export const PairPaysForAddOnsInCreditsList: readonly SourceMethodPair[] = []

export const payForAddOnsInCredits = (
  packageSource: PackageSource,
  billingMethod: ChargeMethod
): boolean =>
  hasPair(PairPaysForAddOnsInCreditsList, packageSource, billingMethod)

export const payForAddOnsInDollars = (
  packageSource: PackageSource,
  billingMethod: ChargeMethod
): boolean => hasPair(AddOnDollarPairs, packageSource, billingMethod)

export const PairUsesCreditsFirstThenDollarsForAddOnsList =
  CreditsFirstThenDollarsPairs

export const creditsFirstThenDollarsForAddOns = (
  packageSource: PackageSource,
  billingMethod: ChargeMethod
): boolean =>
  hasPair(CreditsFirstThenDollarsPairs, packageSource, billingMethod)

// ---------------------------------------------------------------------------
// Bid / pricing rules
// ---------------------------------------------------------------------------

export const totalCostIsBidBased = (
  packageSource: PackageSource,
  billingMethod: ChargeMethod
): boolean => hasPair(MoneyBasedPairs, packageSource, billingMethod)

export const BidCoversWholeProjectList = MoneyBasedPairs

export const bidCoversWholeProject = (
  packageSource: PackageSource,
  billingMethod: NoneableChargeMethod
): boolean => hasPair(MoneyBasedPairs, packageSource, billingMethod)

export const TotalPriceIsMinimumCostList: PackageSource[] = [
  PackageSourceEnum.quickframe,
]

export const totalPriceIsMinimumCost = (
  packageSource: PackageSource
): boolean => TotalPriceIsMinimumCostList.includes(packageSource)

export const ShowPackageCreditsCostList: PackageSource[] = [
  PackageSourceEnum.ctv,
]

export const showPackageCreditsCost = (packageSource: PackageSource): boolean =>
  ShowPackageCreditsCostList.includes(packageSource)
